module.exports = __webpack_public_path__ + "img/pr-5.1cf64dda.png";